import { render } from "./HtmlpageRender.vue?vue&type=template&id=ba02ace8&scoped=true"
import script from "./HtmlpageRender.vue?vue&type=script&lang=js"
export * from "./HtmlpageRender.vue?vue&type=script&lang=js"

import "./HtmlpageRender.vue?vue&type=style&index=0&id=ba02ace8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba02ace8"]])

export default __exports__